/* eslint-disable array-callback-return */
import { get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../../context/ApplicationContext';
import { FormStrucItem } from '../../../../../../../../lib/types/types';
import { addIndexesToPath } from '../../../../../../../../utils/helper';

// import schemas
import Schema from '../../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const KurzfassungAbschlussEmob: FC<{ kostentraeger: string; unternehmenId: number }> = ({ kostentraeger, unternehmenId }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			{get(application, P.Kurzfassung_Zum_Projektende.path, []).map((_ele: any, i: number) => {
				const kostentraegerPath = addIndexesToPath(
					P.Kurzfassung_Zum_Projektende.schema.attributes.Kostentraeger.path,
					[`${i}`],
					['Kurzfassung_Zum_Projektende'],
				);
				const antragstellerPath = addIndexesToPath(
					P.Kurzfassung_Zum_Projektende.schema.attributes.Antragsteller.path,
					[`${i}`],
					['Kurzfassung_Zum_Projektende'],
				);
				const partnerPath = addIndexesToPath(
					P.Kurzfassung_Zum_Projektende.schema.attributes.Verbundpartner.path,
					[`${i}`],
					['Kurzfassung_Zum_Projektende'],
				);
				if (
					get(application, kostentraegerPath) === kostentraeger &&
					(get(application, `${antragstellerPath}.id`) === unternehmenId || get(application, `${partnerPath}.id`) === unternehmenId)
				) {
					return (
						<CreateForm
							key={i}
							formStruc={mapFormStruc(formStrucKurzfassung, i)}
							formValues={application}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={readOnly}
						/>
					);
				}
			})}
		</>
	);
};

export default KurzfassungAbschlussEmob;

const mapFormStruc = (formStruc: any[], i: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Kurzfassung_Zum_Projektende.path.length) +
						`.${i}` +
						pathWithoutIndex.slice(P.Kurzfassung_Zum_Projektende.path.length),
				};
			}),
		};
	});
	return result;
};

const formStrucKurzfassung = [
	{
		fields: [
			P.Kurzfassung_Zum_Projektende.schema.attributes.Kurzfassung_Zum_Projektende_Was_Wurde_Mit_Dem_Projekt_Erreicht,
			P.Kurzfassung_Zum_Projektende.schema.attributes.Kurzfassung_Zum_Projekte_0057123173_ben_Die_Erzielten_Ergebnisse,
		],
		userProps: { direction: 'column', columnToDivide: 1 },
	},
];

export const getFormStrucKurzfassungAbschlussEmob = (application: any, kostentraeger: string, unternehmenId: number) => {
	let result: FormStrucItem[] = [];
	get(application, P.Kurzfassung_Zum_Projektende.path, []).map((_ele: any, i: number) => {
		const kostentraegerPath = addIndexesToPath(
			P.Kurzfassung_Zum_Projektende.schema.attributes.Kostentraeger.path,
			[`${i}`],
			['Kurzfassung_Zum_Projektende'],
		);
		const antragstellerPath = addIndexesToPath(
			P.Kurzfassung_Zum_Projektende.schema.attributes.Antragsteller.path,
			[`${i}`],
			['Kurzfassung_Zum_Projektende'],
		);
		const partnerPath = addIndexesToPath(
			P.Kurzfassung_Zum_Projektende.schema.attributes.Verbundpartner.path,
			[`${i}`],
			['Kurzfassung_Zum_Projektende'],
		);
		if (
			get(application, kostentraegerPath) === kostentraeger &&
			(get(application, `${antragstellerPath}.id`) === unternehmenId || get(application, `${partnerPath}.id`) === unternehmenId)
		) {
			result = mapFormStruc(formStrucKurzfassung, i);
		}
	});
	return result;
};
